module.exports = __webpack_public_path__ + "static/bg-home-c680cc3458404a44cfe6681c967358b0.jpg";